module.exports = __webpack_public_path__ + "img/seed.5e2e2245.svg";